module.exports = __webpack_public_path__ + "static/img/Four_Of_A_Kind.248a16c.svg";